<template>
  <div>
    Hier siehst du mit welchem Konto und Gerät du online bist.
  </div>
</template>

<script>
  import {switchRoom} from './step-utils';


  const component = {
    name: 'StepPeerSelf'
  };


  export const StepPeerSelf = {
    target: '.peer-self',
    before: async () => {
      await switchRoom('local');
    },
    header: 'Das bist du',
    content: component
  };


  export default component;
</script>
